import type { CursorData } from '@alpod-ai-writer/shared';
import { HocuspocusProvider } from '@hocuspocus/provider';
import { createTSlatePlugin, type PluginConfig, type TElement } from '@udecode/plate';
import { toPlatePlugin } from '@udecode/plate/react';
import * as Y from 'yjs';

import { withPlateYjs } from './withPlateYjs';
import { YjsAboveEditable } from './yjsAboveEditable.component';

export type YjsConfig = PluginConfig<
    'yjs',
    {
        provider: HocuspocusProvider;
        getYjsDocumentNode: () => Y.XmlText;
        cursorData: CursorData;
        initialValue?: Partial<TElement>;
        preloadedContent?: TElement;
    }
>;

export const BaseYjsPlugin = createTSlatePlugin<YjsConfig>({
    key: 'yjs',
    extendEditor: withPlateYjs,
    options: {
        getYjsDocumentNode: () => {
            throw new Error('getDocumentField is not defined');
        },
        provider: {} as any,
        cursorData: {
            identityId: 'N/A',
            name: 'N/A',
            initials: 'N/A',
            color: '#000000',
        }
    },
}).extend(({ getOptions }) => {
    const { provider } = getOptions();

    return {
        options: { provider },
    };
});

export const YjsPlugin = toPlatePlugin(BaseYjsPlugin, {
    render: {
        aboveEditable: YjsAboveEditable,
    },
});
